const menu = {
    label: '• Tipo de Serviço',
    to: '/sol/tiposervico',
    rules: ['SOL-001'],
};

export default menu;
